import React from "react";
import {WizClassifySelect} from '@/containers/common';
import {component_tool} from '@/tool'

let {WizDataTable, WizButton} = component_tool

const columns = (self) => {
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "题目内容",
      name: "title",
      dataIndex: "title",
      tableItem: {width: 300},
      searchItem: {},
    },
    {
      title: "题目编码",
      name: "number",
      dataIndex: "number",
      tableItem: {
        width: 220
      },
      searchItem: {}
    },
    {
      title: "题目类型",
      name: "type",
      dataIndex: "type",
      dict: [
        {code: 0, codeName: "单选题"},
        {code: 1, codeName: "多选题"},
        {code: 2, codeName: "判断题"},
        {code: 3, codeName: "填空题"},
        {code: 4, codeName: "主观题"}
      ],
      searchItem: {
        type: "select"
      },
      tableItem: {
        width: 100
      }
    },
    {
      title: "难度",
      name: "difficulty",
      dataIndex: "difficulty",
      dict: [
        {code: 0, codeName: "低"},
        {code: 1, codeName: "中"},
        {code: 2, codeName: "高"}
      ],
      tableItem: {
        width: 100
      },
      searchItem: {
        type: "select"
      }
    },
    {
      title: '操作',
      tableItem: {
        width: 100,
        render: (text, record) => (
          <WizDataTable.Oper>
            <WizButton tooltip="查看" onClick={e => self._onLookBankQuestion(record, e)}>
              查看
            </WizButton>
          </WizDataTable.Oper>
        )
      }
    }
    //#endregion

  ]
}

const tableApi = (api = {}) => {
  const {id, ...other} = api
  let categoryId = null
  if (id && id instanceof Array) {
    categoryId = id[0]
  }
  return {
    path: 'ReviewQuestion/list',
    ...other,
    id: categoryId
  }
}

const bankQuestion = (self, api) => {
  return {
    type: 'diy',
    title: '选择题目',
    initialValue: [],
    rowKey: 'id',
    rowName: 'title',
    columns: columns(self),
    tableApi: tableApi(api)
  }
}

export default bankQuestion
